import React, { useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import DateTimeInputFormik from "../../../../components/UI/DateTimeInput/DateTimeInputFormik";
import TextInputFormik from "../../../../components/UI/TextInput/TextInputFormik";
import TextInputMoneyFormik from "../../../../components/UI/TextInput/TextInputMoneyFormik";
import TextInputMaskFormik from "../../../../components/UI/TextInput/TextInputMaskFormik";
import SelectUf from "../../../../components/UI/SelectInput/SelectUf";
import useAcoesDemonstrativo from "../hooks/useAcoesDemonstrativo";
import useBuscaComposicao from "../hooks/useBuscaComposicao";
import TextInputSpecialNumberFormik from "../../../../components/UI/TextInput/TextInputSpecialNumberFormik";

const DemonstrativoM = ({ formik, sqAcaoFiscal, sqItemOcorrencia, dadosOcorrencia }) => {
  const [tituloUF, setTituloUF] = useState("");
  const [tituloCnpj, setTituloCnpj] = useState("");
  const [disabled, setDisabled] = useState(false);

  const { handleMoneyChange, calculaDataVencimento, calculaBaseCalculo, calculaIcmsGeral } = useAcoesDemonstrativo({formik,});

  const { buscaComposicao, composicao, sentidoOperacao } = useBuscaComposicao({ sqAcaoFiscal, sqItemOcorrencia });

  const { setFieldValue } = formik;

  useEffect(() => {
    if (dadosOcorrencia) {
      setFieldValue("sqAcaoFiscal", sqAcaoFiscal);
      setFieldValue("sqItemOcorrencia", sqItemOcorrencia);
      setFieldValue("sqItem", dadosOcorrencia.sqItem);
      setFieldValue("nuCnpjRemet", dadosOcorrencia.nuCnpjRemet);
      setFieldValue("sequencialUf", dadosOcorrencia.sequencialUf);
      setFieldValue("nuItem", dadosOcorrencia.nuItem);
      setFieldValue("txChave", dadosOcorrencia.txChave);
      setFieldValue("dtEmissao", dadosOcorrencia.dtEmissao);
      setFieldValue("dtVencimento", dadosOcorrencia.dtVencimento);
      setFieldValue("valorTotalNota", dadosOcorrencia.valorTotalNota);
      setFieldValue("vlBaseCalculo", dadosOcorrencia.vlBaseCalculo);
      setFieldValue("vlIcms", dadosOcorrencia.vlIcms);
      setFieldValue("codigoFiscalOperacao", dadosOcorrencia.codigoFiscalOperacao || "");
      setFieldValue("pcAgregadoAuditor", dadosOcorrencia.pcAgregadoAuditor);
      setFieldValue("pcIcmsAuditor", dadosOcorrencia.pcIcmsAuditor);
      setFieldValue("vlCredito", dadosOcorrencia.vlCredito);
      setFieldValue("tipoDetalhamento", dadosOcorrencia.tipoDetalhamento);
    }

    if (composicao === "SNNN") {
      setFieldValue("vlIcms", 0);
      setDisabled(true);
    }

    if (composicao === "NNSS") {
      setDisabled(true);
    }

    if (sqAcaoFiscal !== null) {
      buscaComposicao();
    }
  }, [setFieldValue, dadosOcorrencia, sqAcaoFiscal, sqItemOcorrencia, buscaComposicao, composicao, sentidoOperacao]);

  useEffect(() => {
    if (sentidoOperacao === "S") {
      setTituloUF("UF Destino");
      setTituloCnpj("CNPJ/CPF Destinatário");
    } else {
      // sentidoOperacao = 'E'
      setTituloUF("UF Origem");
      setTituloCnpj("CNPJ/CPF Emitente");
    }
  }, [composicao, sentidoOperacao]);

  return (
    <>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={3}>
          <Form.Label>{tituloCnpj}:</Form.Label>
          <TextInputSpecialNumberFormik formik={formik} field="nuCnpjRemet" />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={3}>
          <Form.Label>{tituloUF}:</Form.Label>
          <SelectUf formik={formik} field="sequencialUf" />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={3}>
          <Form.Label>N° Documento Fiscal:</Form.Label>
          <TextInputFormik formik={formik} field="nuItem" type="text" />
        </Form.Group>
        {!(composicao === "SNNN") && (
          <Form.Group className="mb-3" as={Col} sm={12} md={3}>
            <Form.Label>CFOP:</Form.Label>
            <TextInputMaskFormik formik={formik} field="codigoFiscalOperacao" mask="9999" />
          </Form.Group>
        )}
      </Row>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={3}>
          <Form.Label>Chave:</Form.Label>
          <TextInputSpecialNumberFormik formik={formik} field="txChave" />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={3}>
          <Form.Label>Data de Emissão:</Form.Label>
          <DateTimeInputFormik formik={formik} field="dtEmissao" evento={calculaDataVencimento} />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={3}>
          <Form.Label>Data de Vencimento:</Form.Label>
          <DateTimeInputFormik formik={formik} field="dtVencimento" />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={3}>
          <Form.Label>Valor Documento (R$):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="valorTotalNota"
            type="number"
            prefix=" "
            onChange={handleMoneyChange}
          />
        </Form.Group>

        {composicao === "NNSS" && (
          <Form.Group className="mb-3" as={Col} sm={12} md={3}>
            <Form.Label>Agregado (%):</Form.Label>
            <TextInputMoneyFormik
              formik={formik}
              field="pcAgregadoAuditor"
              type="number"
              prefix=" "
              onChange={handleMoneyChange}
              evento={calculaBaseCalculo}
            />
          </Form.Group>
        )}

        {!(composicao === "SNNN") && (
          <Form.Group className="mb-3" as={Col} sm={12} md={3}>
            <Form.Label>Valor Base de Cálculo (R$):</Form.Label>
            <TextInputMoneyFormik
              formik={formik}
              field="vlBaseCalculo"
              type="number"
              prefix=" "
              onChange={handleMoneyChange}
              disable={disabled}
            />
          </Form.Group>
        )}
      </Row>
      <Row>
        {composicao === "NNSS" && (
          <>
            <Form.Group className="mb-3" as={Col} sm={12} md={3}>
              <Form.Label>Alíquota (%):</Form.Label>
              <TextInputMoneyFormik
                formik={formik}
                field="pcIcmsAuditor"
                type="number"
                prefix=" "
                onChange={handleMoneyChange}
              />
            </Form.Group>
            <Form.Group className="mb-3" as={Col} sm={12} md={3}>
              <Form.Label>Valor Crédito/Deduções (R$):</Form.Label>
              <TextInputMoneyFormik
                formik={formik}
                field="vlCredito"
                type="number"
                prefix=" "
                onChange={handleMoneyChange}
                evento={calculaIcmsGeral}
              />
            </Form.Group>
          </>
        )}
        <Form.Group className="mb-3" as={Col} sm={12} md={3}>
          <Form.Label>ICMS a Recolher (R$):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="vlIcms"
            type="number"
            prefix=" "
            onChange={handleMoneyChange}
            disable={disabled}
          />
        </Form.Group>
      </Row>
    </>
  );
};
export default DemonstrativoM;
